var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32830)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#008200"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.31938 12.9375H7.308L6.69937 10.5469L8.18719 9.7695L8.6715 11.1532L9.03206 9.32794L11.0093 8.29463L10.9001 8.84363L12.042 8.85431C12.483 8.84756 12.8244 8.6985 13.0674 8.40825C13.3104 8.11744 13.4258 7.72762 13.4134 7.23656C13.4114 7.17335 13.4048 7.11037 13.3937 7.04812L14.9293 6.24544C15.1419 6.63637 15.2229 7.09706 15.1734 7.62637C15.0913 8.39812 14.7572 9.01575 14.1727 9.47869C13.5883 9.94219 12.843 10.1739 11.9379 10.1739L10.6408 10.1683L10.0913 12.9375H8.31938ZM8.55619 6.75563H9.54056L8.0235 8.90719L4.27725 10.8653L5.6655 8.90213L4.33125 5.0625H6.28875L6.98063 7.75631L7.57237 6.75506L8.62875 5.0625H9.87469L12.7581 5.06813C13.4134 5.08613 13.9506 5.25994 14.3702 5.58956L12.7952 6.41306C12.7565 6.40588 12.7174 6.401 12.6782 6.39844L11.3878 6.38719L11.2191 7.23656L9.24075 8.27044L9.54 6.75506L8.55619 6.75563ZM3.25462 12.348L6.25106 10.7814L4.93031 12.9375H2.8125L3.24394 12.3272L3.25462 12.348Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32830"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXp);
export default __webpack_public_path__ + "static/media/xp.56a3a33b21cf1aa09be526f2bc6d21c0.svg";
export { ForwardRef as ReactComponent };